import './Payment.css';
import React, { useState, useEffect } from 'react';
import { useSelector , useDispatch} from 'react-redux'
import {getPayment} from '../../../store/api.js'

export function Payment(props) {
    const dispatch= useDispatch()
    const { payments, statusPay } = useSelector(state => state.payment) 
    const [error, setError] = useState(null);
   console.log(payments)
    useEffect(() => {
      dispatch(getPayment())
    }, []);
  
    if (statusPay ==='loading') return <div>Загрузка...</div>;
    if (error) return <div>Ошибка: {error}</div>;
    if (payments.length === 0) return <div>Платежей не найдено</div>;
  
    return (
      <div className='pay__container' >
        <h2  className='pay__title font24Norm'  >Список платежей</h2>
        <table className='pay__table' >
          <thead>
            <tr>
              <th >userId</th>
              <th  >Сумма</th>
              <th  >Подписка</th> 
              <th  >Статус</th>
              <th  >Дата</th>
              <th >Период</th>
              <th >Бонусы</th>
              <th >PayId</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id}  >
                <td  >{payment.metadata.userId}</td>
                <td >
                  {payment.amount.value} {payment.amount.currency}
                </td>
                <td >
                  {payment.metadata.subsId}   
                </td>
                <td >
                  <span  className={` ${payment.status === 'succeeded' ? 'pay__ok' : 'pay__red'}`}>
                    {payment.status}
                  </span>
                </td>
                <td >
                  {new Date(payment.created_at).toLocaleString()}
                </td> 
                <td  >{payment.metadata.period || '-'}</td>
                <td >
                  {payment.metadata.usedBonus}    
                </td>
                <td >
                  {payment.id}   
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
}

// Стили для статусов
const getStatusStyle = (status) => {
    const base = {
      padding: '4px 8px',
      borderRadius: '4px',
      fontWeight: 'bold',
      textTransform: 'capitalize',
    };
  
    switch (status) {
      case 'succeeded':
        return { ...base, backgroundColor: '#d4edda', color: '#155724' };
      case 'pending':
        return { ...base, backgroundColor: '#fff3cd', color: '#856404' };
      case 'canceled':
        return { ...base, backgroundColor: '#f8d7da', color: '#721c24' };
      default:
        return { ...base, backgroundColor: '#e2e3e5', color: '#383d41' };
    }
  };